import { ServiceReportTextMetadata, ServiceReportImageMetadata, SectionProps, ServiceReportProps, ServiceReportMultiSelectMetadata, ReactComponentMetadata } from "./service_report_metadata/servicereport_text_component";
import { Config } from "../../core/config/config";

export class CustomReportMetadataDescriptor {
    private getQuestionMetadata = (node) => {
        if (node.metadata.Type == 12) {
            return ServiceReportImageMetadata;
        }
        else if (node.metadata.Type == 5 || node.metadata.Type == 6 || node.metadata.Type == 11) {
            return ServiceReportMultiSelectMetadata;
        }
        else if (node.metadata.Type == 13) {
            return ReactComponentMetadata;
        }
        return ServiceReportTextMetadata;
    }

    private getSectionMetadata = (node) => {
        return SectionProps;
    }

    private getReportMetadata = (node) => {
        return ServiceReportProps;
    }

    private getComponentName(type): string {
        switch (type) {
            case 1:
                return "Int";
            case 2:
                return "Float";
            case 3:
                return "Check box";
            case 0:
            case 4:
                return "Text";
            case 5:
                return "Radio buttons";
            case 6:
                return "Check boxes";
            case 8:
                return "Local date";
            case 11:
                return "Picklist";
            case 12:
                return "Image";
            default:
        }
    }
    public questionDescriptor: TreeMetadataDescriptor = {
        descriptorName: "questionDescriptor",
        getTitle: (node: Question) => {
            if (node.Type == 12) {
                return "Documents";
            }
            if (node.Type == 13) {
                return "React component";
            }
            else {
                let text = node.OverriddenText || node.Text || '';
                text = (text.length <= 25 ? text : (text.substring(0, 25)) + "...")
                return text || "";
            }
        },
        getMetadata: this.getQuestionMetadata
    }

    public sectionDescriptor: TreeMetadataDescriptor = {
        descriptorName: "sectionDescriptor",
        getTitle: (node: Section) => {
            const translatedText = this.getTranslatedText(node.TranslatableTitle);
            return translatedText || "Section";
        },
        childrenArrayName: (node: Section) => "Questions",
        childrenDescriptor: this.questionDescriptor,
        getMetadata: this.getSectionMetadata
    }
    public reportDescriptor: TreeMetadataDescriptor = {
        descriptorName: "servicereportDescriptor",
        getTitle: (node: ServiceReport) => "Service report",
        childrenArrayName: (node: ServiceReport) => "Sections",
        childrenDescriptor: this.sectionDescriptor,
        getMetadata: this.getReportMetadata
    }

    private getTranslatedText = (values) => {

        if (values) {
            const result = values.filter(v => v["Language"] == Config.user.languageId)
            if (result && result.length > 0) {
                return result[0]["Translation"]
            }
        }

        return "";
    }
}

export interface TreeMetadataDescriptor {
    descriptorName: string
    getTitle(node: any): string
    childrenArrayName?(node: any): string
    childrenDescriptor?: TreeMetadataDescriptor
    getMetadata?(node: any)
}

interface ServiceReport {
    Title: string
    Sections: Section[]
}

interface Section {
    Title: string
    Rows: Row[]
    TranslatableTitle: any
}

interface Row {
    Questions: Question[];
}

interface Question {
    Text: string;
    Type: number;
    OverriddenText: string;
}